import { AppState } from "../../store";

export const getPartCategories = (state: AppState) => state.reducer.Parts.partCategories